// extracted by mini-css-extract-plugin
export default {"root":"VideoArea_root__N2B+i"};